import { useMediaQuery } from "@mui/material";
import SwipeListener from "swipe-listener";
// import { isMobile } from "react-device-detect";

import { setTableModal } from "../redux/features/settingSlice";

export const TableModalSwipe = (dispatch) => {
  var container = document.querySelector(".tableModal");
  // eslint-disable-next-line no-unused-vars
  var listener = SwipeListener(container);

  container.addEventListener("swipe", function (e) {
    var directions = e.detail.directions;
    // var x = e.detail.x;
    var y = e.detail.y;

    if (directions.left) {
      //   console.log("Swiped left.");
    }

    if (directions.right) {
      //   console.log("Swiped right.");
    }

    if (directions.top) {
      //   console.log("Swiped top.");
      if (y[0] - y[1] > 120) {
        dispatch(setTableModal(true));
      }
    }

    if (directions.bottom) {
      // console.log("Swiped bottom.");
      if (y[1] - y[0] > 180) {
        dispatch(setTableModal(false));
      }
    }

    // console.log("Started horizontally at", x[0], "and ended at", x[1]);
    // console.log("Started vertically at", y[0], "and ended at", y[1]);
  });
};

export function TableModalHeight() {
  const height1 = useMediaQuery("(max-width:415px)");
  const height2 = useMediaQuery("(max-width:370px)");

  var modalHeight = 285;

  if (!height1 && !height2) {
    // eslint-disable-next-line no-unused-vars
    modalHeight = 285;
  } else if (height1 && !height2) {
    // eslint-disable-next-line no-unused-vars
    modalHeight = 240;
  } else if (height1 && height2) {
    // eslint-disable-next-line no-unused-vars
    modalHeight = 220;
  }
  return modalHeight;
}

export function BadgeHeight() {
  const height1 = useMediaQuery("(max-width:415px)");
  const height2 = useMediaQuery("(max-width:370px)");
  const height3 = useMediaQuery("(max-width:350px)");

  var badgeHeight = 18;
  if (height3) {
    badgeHeight = 40;
  } else if (!height1 && !height2) {
    // eslint-disable-next-line no-unused-vars

    badgeHeight = 18;
  } else if (height1 && !height2) {
    // eslint-disable-next-line no-unused-vars

    badgeHeight = 18;
  } else if (height1 && height2) {
    // eslint-disable-next-line no-unused-vars

    badgeHeight = 20;
  }
  return badgeHeight;
}

export const topicSwipe = (setOpenDes) => {
  var container = document.querySelector(".detail-des");
  // eslint-disable-next-line no-unused-vars
  var listener = SwipeListener(container);

  container.addEventListener("swipe", function (e) {
    var directions = e.detail.directions;
    // var x = e.detail.x;
    var y = e.detail.y;

    if (directions.left) {
      //   console.log("Swiped left.");
    }

    if (directions.right) {
      //   console.log("Swiped right.");
    }

    if (directions.top) {
      //   console.log("Swiped top.");
      if (y[0] - y[1] > 60) {
        setOpenDes(false);
      }
    }

    if (directions.bottom) {
      // console.log("Swiped bottom.");
      if (y[1] - y[0] > 120) {
        setOpenDes(true);
      }
    }
  });
};

export const playerSwipe = (top, bottom, setTop, setBottom, setFirstRender) => {
  var container = document.querySelector(".player-page");
  // eslint-disable-next-line no-unused-vars
  var listener = SwipeListener(container);

  container.addEventListener("swipe", function (e) {
    var directions = e.detail.directions;
    // var x = e.detail.x;
    var y = e.detail.y;
    if (directions.top) {
      if (y[0] - y[1] > 50) {
        setFirstRender(true);
        setTop(!top);
        // console.log("prev");
      }
    }

    if (directions.bottom) {
      if (y[1] - y[0] > 50) {
        setFirstRender(true);
        setBottom(!bottom);
        // console.log("next");
      }
    }
  });
};
